import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
	CurrencyCode,
	DepartmentPayrollCurrencyUpdateResponse
} from '../../../models/payroll-currency.model';
import { AdminService } from '../../../services/admin.service';

@Injectable()
export class ViewGroupPayrollCurrencyPort {
	constructor(private adminService: AdminService) {}

	update(
		groupId: string,
		payrollCurrency: CurrencyCode
	): Observable<HttpResponse<DepartmentPayrollCurrencyUpdateResponse>> {
		return this.adminService.updateDepartmentPayrollCurrency(groupId, payrollCurrency);
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-payroll-currency.port.ts